import * as React  from 'react';
import { NavLink } from 'react-router-dom';

import './scss/style.scss';

import { useCatalog }   from '../../providers/catalog';
import { useSearch }    from '../../providers/search';
import { useSidebar }   from '../../providers/sidebar';
import sidebarConstants from '../../providers/sidebar/sidebar.constants';

import CatalogIcon    from '../icons/CatalogIcon';
import WhereByIcon    from '../icons/WhereByIcon';
import CallMeFormIcon from '../icons/CallMeFormIcon';
import SearchIcon     from '../icons/SearchIcon';
import BookmarksIcon  from '../icons/BookmarksIcon';

const BottomMenu = function() {
  const catalog = useCatalog();
  const search  = useSearch();
  const sidebar = useSidebar();

  return (
    <div className={'bottom-menu'}>
      <ul>
        <li>
          <NavLink
            onClick={() => {
              void catalog.resetFilter();
              void catalog.getCatalogItems('/vhodnye-dveri');
            }}
            to={'/vhodnye-dveri'}
          ><CatalogIcon /></NavLink>
        </li>
        <li>
          <NavLink to={'/gde-kupit-kontakty'}><WhereByIcon /></NavLink>
        </li>
        <li
          onClick={() => {
            sidebar.showSidebar(sidebarConstants.CALL_ME_SIDEBAR);
          }}
        >
          <CallMeFormIcon />
        </li>
        <li onClick={search.searchOpen}>
          <SearchIcon />
        </li>
        <li>
          <NavLink to={'/izbrannoe'}><BookmarksIcon /></NavLink>
        </li>
      </ul>
    </div>
  );
};

export default BottomMenu;
